import Vue from 'vue';

export default function() {
	const { apiBase } = window.$config;
	Vue.$ofsCrud.addResource({
		name: 'auth',
		pluralName: 'auth',
		transport: 'http',
		options: { namespaced: true },
		state: {},
		mutations: {},
		actions: {
			async getResetPasswordToken({ dispatch }, { token }) {
				let response = null;
				try {
					response = await dispatch('request', {
						method: 'GET',
						path: `${apiBase}/auth/reset/check/${token}`
					});
				} catch (e) {
					return { success: false, error: e };
				}
				return { success: true, data: response.data };
			},
			async getInvitation({ dispatch }, { token }) {
				let response = null;
				try {
					response = await dispatch('request', {
						method: 'GET',
						path: `${apiBase}/invitation/${token}`
					});
				} catch (e) {
					return { success: false, error: e };
				}
				return { success: true, data: response.data };
			},
			async acceptInvitation({ dispatch }, { invitation }) {
				let response = null;
				try {
					response = await dispatch('request', {
						method: 'POST',
						payload: invitation,
						path: `${apiBase}/invitation/consume`
					});
				} catch (e) {
					return { success: false, error: e };
				}
				return { success: true, data: response.data };
			},
			async changePassword({ dispatch }, { password, token }) {
				let response = null;
				try {
					response = await dispatch('request', {
						method: 'POST',
						payload: {
							password,
							token
						},
						path: `${apiBase}/auth/reset`
					});
				} catch (e) {
					return { success: false, error: e };
				}
				return { success: true, data: response.data };
			}
		},
		getters: {}
	});
}
